<p>pallet-archive works!</p>
